import React from "react"
import logo from "assets/images/logo.png"
import classNames from "utils/classNames"

export type VesatogoBrandProps = React.ComponentProps<"img"> & {
  brandText?: string
  className?: string
  imgClassName?: string
}
const VesatogoBrand = ({
  width = "48",
  brandText,
  className,
  imgClassName,
  ...OtherLogoProps
}: VesatogoBrandProps) => (
  <>
    <img
      src={logo}
      className={classNames("header-brand-img pr-2", imgClassName)}
      width={width}
      alt="Logo"
      {...OtherLogoProps}
    />
    {brandText && (
      <span className={classNames("vt-brand-name", className)}>
        {brandText}
      </span>
    )}
  </>
)

export default VesatogoBrand
